import React from "react";
import { connect } from "react-redux";
import "./styles.css";
import { Table } from "../../Table";
import { Button } from "../../Button";

const items = [
  {
    name: "Item Name",
    quantity: 1,
    amount: 1000,
  },
  {
    name: "Item Name",
    quantity: 1,
    amount: 1000,
  },
  {
    name: "Item Name",
    quantity: 1,
    amount: 1000,
  },
];

class InvoicePreview extends React.Component {
  render() {
    return (
      <div className="invoice-preview-container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <div className="card invoice-preview-content">
              <div className="header">
                <div style={{ flex: 1 }}>
                  <h3 className="title">Invoice</h3>
                  <p>2309-KE</p>
                </div>
                <div>
                  <p>
                    <span>Issued Date </span>
                    <b>14/05/2024</b>
                  </p>
                  <p>
                    <span>Due Date </span>
                    <b>30/05/2024</b>
                  </p>
                </div>
              </div>

              <div className="bill-container">
                <div className="bill_item">
                  <p className="title">Bill From</p>
                  <h3>DIL Name 01</h3>
                </div>
                <div className="bill_item">
                  <p className="title">Bill To</p>
                  <h3>Client Name</h3>
                  <p>+24407323233</p>
                </div>
              </div>
              <div className="card-body">
                <table
                  className="table table-condensed"
                  style={{ paddingBottom: 0 }}
                >
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th style={{ textAlign: "right" }}>Qty</th>
                      <th style={{ textAlign: "right" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((el, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <b>{el.name}</b>
                          </td>
                          <td align="right">x{el.quantity}</td>
                          <td align="right">{el.amount}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={2} align="right">
                        SubTotal:
                      </td>
                      <td align="right">
                        <b>5000</b>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2} align="right">
                        Total Fees:
                      </td>
                      <td align="right">
                        <b>0</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card-body d-flex">
                <div style={{ flex: 1 }}></div>
                <div style={{ textAlign: "right" }}>
                  <Button
                    text="Pay Now"
                    onPress={() =>
                      (window.location.href =
                        "https://checkout.uat.mobitill.com/")
                    }
                  />
                </div>
              </div>
              <div className="footer">
                <div className="">
                  <p>
                    Powered by <b>DIL</b>
                  </p>
                </div>
                <div className="">
                  <a href="tel:0711520705">071 1520 705</a>
                </div>
                <div className="">
                  <a href="mailto=sales@dataintegrated.co.ke">
                    sales@dataintegrated.co.ke
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(InvoicePreview);
